export const SIDEBAR_SHRUNK_STORAGE_KEY = 'sidebarShrunk'

// Only an explicit preference overrides the default: the sidebar is meant to
// start compact, and several pages collapse it on their own for screen space.
const getInitialShrunk = () => {
  if (typeof localStorage === 'undefined') return true

  const saved = localStorage.getItem(SIDEBAR_SHRUNK_STORAGE_KEY)

  return saved === null ? true : saved === 'true'
}

export default {
  isShrunk: getInitialShrunk(),
  hasUntrackedTags: false,
  hasUntrackedType: false,
}
